import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { PentestCalendarEvent } from '../models';
import { DemoStore } from '../stores';
import { DemoDataService } from './demo-data.service';

@Injectable({
  providedIn: 'root',
})
export class PentestCalendarService {
  private readonly httpClient = inject(HttpClient);
  private readonly demoStore = inject(DemoStore);
  private readonly demoDataService = inject(DemoDataService);

  getPentestEvents(): Observable<PentestCalendarEvent[]> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getPentestCalendarEvents());
    }

    return this.httpClient
      .get<any[]>('/api/admin/pentest-calendar')
      .pipe(map((events) => events.map((event) => PentestCalendarEvent.mapFromApiValue(event))));
  }

  getPartnerPentestEvents(partnerId?: string): Observable<PentestCalendarEvent[]> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getPartnerPentestCalendarEvents());
    }

    return this.httpClient
      .get<any[]>(`/api/partners/${partnerId || 'me'}/configs/calendar`)
      .pipe(map((events) => events.map((event) => PentestCalendarEvent.mapFromApiValue(event))));
  }

  getCustomerPentestEvents(customerId?: number): Observable<PentestCalendarEvent[]> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getPentestCalendarEvents());
    }

    return this.httpClient
      .get<any[]>(`/api/customers/${customerId || 'me'}/configs/calendar`)
      .pipe(map((events) => events.map((event) => PentestCalendarEvent.mapFromApiValue(event))));
  }

  updateSchedule(customerId: number | string, configId: number, nextRuntime: string): Observable<void> {
    if (this.demoStore.isDemoMode()) {
      return of(void 0);
    }

    return this.httpClient.put<void>(`/api/customers/${customerId || 'me'}/configs/${configId}/schedule`, {
      nextRunTime: nextRuntime,
    });
  }
}
